export function matchesSearch(search: string, values: Array<unknown>) {
  const query = normalizeSearch(search);
  if (!query) return true;
  return values.some((value) => normalizeSearch(value).includes(query));
}

export function normalizeSearch(value: unknown) {
  return String(value ?? '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
}
